import Rails from '@rails/ujs';

Rails.start();

export default Rails;
